import React from "react";
import logo from "../assets/icons/logo.svg";

const Logo=() => {

    return(
        <>
    <img src={logo} alt="logo" />
</>
    )
}
export default Logo;